import React, { useMemo } from "react";
import { IonFooter, IonToolbar } from "@ionic/react";
import { Button, Stack, Typography } from "@mui/material";
import { isIOSNative, isIOSWeb } from "../../utils/platform";
import "./SignatureDevFooter.css";

type SignatureDevFooterProps = {
  onDriverClick?: () => void;
  onRecipientClick?: () => void;
};

const SignatureDevFooter: React.FC<SignatureDevFooterProps> = ({
  onDriverClick,
  onRecipientClick,
}) => {
  const isIOS = useMemo(() => isIOSWeb() || isIOSNative(), []);

  const footerClassName = [
    "signature-dev-footer",
    isIOS ? "signature-dev-footer--ios" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <IonFooter slot="fixed" className={footerClassName}>
      <IonToolbar className="signature-dev-footer__toolbar">
        <div className="signature-dev-footer__content">
          <Typography
            variant="subtitle2"
            color="text.secondary"
            className="signature-dev-footer__label"
          >
            Shipment Signatures
          </Typography>
          <Stack
            spacing={1}
            direction={{ xs: "column", sm: "row" }}
            className="signature-dev-footer__buttons"
          >
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={onDriverClick}
            >
              Collect Driver Signature
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={onRecipientClick}
            >
              Collect Recipient Signature
            </Button>
          </Stack>
        </div>
      </IonToolbar>
    </IonFooter>
  );
};

export default SignatureDevFooter;
